/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/commonPagination.scss';
import classNames from 'classnames';

import React, {MouseEventHandler, useMemo} from 'react';

import {AwesomeIcon, ChangeFunction} from '@dvrd/dvr-controls';

import {BluemateSelect} from '../controls';

import {BluemateSelectItem} from '../../util/interfaces';

interface Props {
    onChangePage: (page: number) => MouseEventHandler;
    onChangeLimit?: ChangeFunction<number>;
    page: number;
    total: number;
    limit: number;
    limitItems?: Array<BluemateSelectItem>;
    limitItemsPosition?: 'top' | 'bottom';
    className?: string;
}

export default function CommonPagination(props: Props) {
    const {page, onChangePage, total, limit, onChangeLimit, limitItems, limitItemsPosition, className} = props;
    const from = Math.min(page * limit + 1, total),
        to = Math.min(from + limit - 1, total);
    const maxPage = Math.ceil(total / limit),
        prevDisabled = page === 0,
        nextDisabled = page >= maxPage - 1;
    const editableLimit = useMemo(() => {
        return !!onChangeLimit && !!limitItems;
    }, [onChangeLimit, limitItems]);
    return (
        <div className={classNames('common-pagination', editableLimit && 'with-limit', className)}>
            <label className='from-to'>
                {from} - {to} van {total}
            </label>
            <div className='pagers'>
                <AwesomeIcon
                    name='chevron-left'
                    onClick={prevDisabled ? undefined : onChangePage(page - 1)}
                    className={classNames('pager', prevDisabled && 'disabled')}
                />
                <AwesomeIcon
                    name='chevron-right'
                    onClick={nextDisabled ? undefined : onChangePage(page + 1)}
                    className={classNames('pager', nextDisabled && 'disabled')}
                />
            </div>
            {editableLimit && (
                <BluemateSelect
                    onChange={onChangeLimit!}
                    value={limit}
                    items={limitItems!}
                    itemsPosition={limitItemsPosition}
                />
            )}
        </div>
    );
}
